import { isMetaPixelEnabled } from "../env";
import { isClient } from "../utils";

/**
 * Track a Meta Pixel conversion event on the client-side.
 * Use standard Meta event names (e.g. "Lead", "PageView") so they map to
 * Meta's built-in conversion reporting.
 */
export function trackMetaEvent(
  eventName: string,
  params: Record<string, unknown> = {},
  options?: { eventID: string },
): void {
  if (!isMetaPixelEnabled() || !isClient()) return;

  window.fbq?.("track", eventName, params, options);
}
